import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Switch } from 'components/Switch';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import './FormSwitch.scss';
/**
 * @component FormSwitch
 * @since 1.0.0
 */
export function FormSwitch(props) {
    let { name, style, label, infos, error, required, optional, disabled, tooltip, prefix, suffix } = Object.assign({ style: 'normal' }, props);
    const form = useForm();
    const [ident] = useIdent('form-switch');
    const [active, setActive] = useValue(name, props.active, false);
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(active) {
        setActive(active);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(active);
        }
    }, [active]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-switch', 'form-switch--' + style, { 'form-switch--is-required': required }, { 'form-switch--is-optional': optional }, { 'form-switch--is-disabled': disabled }, { 'form-switch--is-focused': focused }, { 'form-switch--is-active': active }, { 'form-switch--has-label': label }, { 'form-switch--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-switch-field" },
            React.createElement("div", { className: "form-switch-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-switch-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-switch-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-switch-field-body" },
                React.createElement(Input, { name: name, ident: ident, error: error, prefix: prefix, suffix: suffix, active: active, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }))),
        React.createElement(FormFieldError, { error: error })));
}
/**
 * @component Input
 * @since 1.0.0
 * @hidden
 */
function Input(props) {
    const { ident, active, required, disabled, prefix, suffix } = props;
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(active) {
        if (props.onChange) {
            props.onChange(active);
        }
    }
    return (React.createElement(Fragment, null,
        prefix && React.createElement("div", { className: "form-switch-prefix" }, prefix),
        React.createElement(Switch, { id: ident, active: active, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
        suffix && React.createElement("div", { className: "form-switch-suffix" }, suffix)));
}
